import { render, staticRenderFns } from "./PanduanList.vue?vue&type=template&id=164f48a3&"
import script from "./PanduanList.vue?vue&type=script&lang=js&"
export * from "./PanduanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports